// One early roster read that may paint before the full answer. A later full answer supersedes it,
// an empty one is no answer, and a failure is reported and changes nothing.
export interface MirrorFirstRead<T> {
  whenReady(apply: (rows: T[]) => void): void;
  supersede(): void;
}

export function mirrorFirst<T>(
  read: () => Promise<T[]>,
  report: (err: unknown) => void,
): MirrorFirstRead<T> {
  let superseded = false;
  const settled = Promise.resolve()
    .then(read)
    .then((r) => (Array.isArray(r) ? r : []))
    .catch((err: unknown): T[] => {
      report(err);
      return [];
    });
  return {
    whenReady(apply) {
      void settled.then((r) => {
        if (!superseded && r.length > 0) apply(r);
        return undefined;
      });
    },
    supersede() {
      superseded = true;
    },
  };
}
